<template>
	<div class="counter-customize-buttons">
		<AppList :items="itemsButtons" />
	</div>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import {useLanguageStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";

export default {
	setup() {
		let userStore = useUserStore();
		let languageStore = useLanguageStore();
		return {getString: languageStore.getString, userStore};
	},
	name: "CounterCustomizeButtons",
	components: {AppList},
	data() {
		return {
			primaryOptions: [{
				id: 'prepare',
				name: this.getString("prepare")
			}, {
				id: 'payment',
				name: this.getString("payment")
			}],
		}
	},
	computed: {
		itemsButtons() {
			return [
				{
					title: this.getString("primary_action"),
					selectValues: this.primaryOptions.map((o) => o.name),
					selectedIndex: this.selectedPrimaryIndex,
					callbackSelect: this.setPrimaryAction
				},
				{
					title: this.getString("hide_secondary_action"),
					switch: true,
					active: this.userStore.currBusiness && this.userStore.currBusiness.counter_hide_secondary,
					callback: (v) => {
						this.userStore.currBusiness.counter_hide_secondary = v;
					},
				},
				{
					title: this.getString("hide_subtotal"),
					switch: true,
					active: this.userStore.currBusiness && this.userStore.currBusiness.counter_hide_subtotal,
					callback: (v) => {
						this.userStore.currBusiness.counter_hide_subtotal = v;
					},
				},
				{
					title: this.getString("payment_shortcut"),
					switch: true,
					active: this.userStore.currBusiness && this.userStore.currBusiness.counter_shortcut === 'card',
					callback: (v) => {
						if(v) {
							this.userStore.currBusiness.counter_shortcut = 'card';
						} else {
							this.userStore.currBusiness.counter_shortcut = null;
						}
					},
				},
			];
		},
		selectedPrimaryIndex() {
			if(!this.userStore.currBusiness) {
				return 0;
			}

			let i = this.primaryOptions.findIndex((o) => o.id === this.userStore.currBusiness.counter_primary);
			if(i === -1) {
				return 0;
			}
			return i;
		},
	},
	methods: {
		setPrimaryAction(index) {
			this.userStore.currBusiness.counter_primary = this.primaryOptions[index].id;
		}
	}
}
</script>

<style scoped lang="scss">
.counter-customize-buttons {
	width: 100%;
}
</style>